/*
 * Copyright(c) 2022 General Electric Company. All rights reserved.
 *
 * The copyright to the computer software herein is the property of
 * General Electric Company. The software may be used and/or copied only
 * with the written permission of General Electric Company or in accordance
 * with the terms and conditions stipulated in the agreement/contract
 * under which the software has been supplied.
 */

import { Component } from '@angular/core';
import { ModalConfig, ModalRef } from '@wfm/core';
import { Logger } from '@core/lib/services';

const _log = new Logger('ConfirmationActionComponent');

@Component({
  selector: 'app-confirmation-action',
  templateUrl: './confirmation-action.component.html',
  styleUrls: ['./confirmation-action.component.scss']
})
export class ConfirmationActionComponent {
  isProcessing = false;
  constructor(public config: ModalConfig, public modalRef: ModalRef) {}

  onClose(value: boolean) {
    if (value) {
      this.isProcessing = true;
      this.config.data.callBack().finally(() => {
        this.isProcessing = false;
        this.modalRef.close();
      });
    } else {
      this.modalRef.close();
    }
  }
}
